package com.vizio.redwolf.utils

data class ConsentV2EnvironmentConfig(val environmentGroup: EnvironmentGroup, val apiKey: String)